const AIV_FETCHING_DATA = 'AIV_FETCHING_DATA'
const AIV_FETCHING_DATA_SUCCESS = 'AIV_FETCHING_DATA_SUCCESS'
const AIV_FETCHING_DATA_ERROR = 'AIV_FETCHING_DATA_ERROR'
const AIV_SELECT_ANSWER = 'AIV_SELECT_ANSWER'
const AIV_SUBMITTING_ANSWER = 'AIV_SUBMITTING_ANSWER'
const AIV_SUBMITTING_ANSWER_SUCCESS = 'AIV_SUBMITTING_ANSWER_SUCCESS'
const AIV_SUBMITTING_ANSWER_ERROR = 'AIV_SUBMITTING_ANSWER_ERROR'
const AIV_RETRIEVED_ANSWER = 'AIV_RETRIEVED_ANSWER'
const AIV_MARK_COMPLETE = 'AIV_MARK_COMPLETE'
const AIV_SET_ACTIVE_ITEM = 'AIV_SET_ACTIVE_ITEM'
const AIV_SET_MOST_RECENT_ACTIVITY = 'AIV_SET_MOST_RECENT_ACTIVITY'
const AIV_CLEAR_MOST_RECENT_ACTIVITY = 'AIV_CLEAR_MOST_RECENT_ACTIVITY'

export function fetchingData () {
  return {
    type: AIV_FETCHING_DATA,
  }
}

export function fetchingDataSuccess (data) {
  return {
    type: AIV_FETCHING_DATA_SUCCESS,
    data,
  }
}

export function fetchingDataError (error) {
  return {
    type: AIV_FETCHING_DATA_ERROR,
    error,
  }
}

export function selectAnswer (selectedAnswer) {
  return {
    type: AIV_SELECT_ANSWER,
    selectedAnswer,
  }
}

export function submittingAnswer () {
  return {
    type: AIV_SUBMITTING_ANSWER,
  }
}

export function submittingAnswerError (error) {
  return {
    type: AIV_SUBMITTING_ANSWER_ERROR,
    error,
  }
}

export function submittingAnswerSuccess (activity) {
  return {
    type: AIV_SUBMITTING_ANSWER_SUCCESS,
    activity,
  }
}

export function retrievedAnswer (answer) {
  return {
    type: AIV_RETRIEVED_ANSWER,
    answer,
  }
}

export function markComplete (itemActivity) {
  return {
    type: AIV_MARK_COMPLETE,
    activity: itemActivity,
  }
}

export function setActiveItem (activeItem, completed) {
  return {
    type: AIV_SET_ACTIVE_ITEM,
    activeItem,
    completed,
  }
}

export function setMostRecentActivity (mostRecentActivity) {
  return {
    type: AIV_SET_MOST_RECENT_ACTIVITY,
    mostRecentActivity,
  }
}

export function clearMostRecentActivity () {
  return {
    type: AIV_CLEAR_MOST_RECENT_ACTIVITY,
  }
}

const initialState = {
  isFetching: false,
  assignment: null,
  userAssignment: null,
  error: '',
  activeItem: null,
  selectedAnswer: '',
  completed: false,
  itemActivity: null,
  submittingAnswer: false,
  mostRecentActivity: null,
}

export function assignmentsItemView (state = initialState, action) {
  switch (action.type) {
    case AIV_FETCHING_DATA :
      return {
        ...state,
        isFetching: true,
      }
    case AIV_FETCHING_DATA_SUCCESS :
      return {
        ...state,
        isFetching: false,
        assignment: action.data.assignment,
        userAssignment: action.data.userAssignment,
        activeItem: action.data.activeItem,
        completed: false,   // this might eventually need attention. Maybe compute on fetchingData instead of having handling with another action
        selectedAnswer: '',  // see above
      }
    case AIV_FETCHING_DATA_ERROR :
      return {
        ...state,
        isFetching: false,
        error: action.error,
      }
    case AIV_SELECT_ANSWER :
      return {
        ...state,
        selectedAnswer: action.selectedAnswer,
      }
    case AIV_SUBMITTING_ANSWER :
      return {
        ...state,
        submittingAnswer: true,
      }
    case AIV_SUBMITTING_ANSWER_SUCCESS : 
      return {
        ...state,
        completed: true,
        userAssignment: {
          ...state.userAssignment,
          activity: {
            ...state.userAssignment.activity,
            [action.activity.activityId]: action.activity,
          }
        },
        submittingAnswer: false,
      }
    case AIV_SUBMITTING_ANSWER_ERROR : 
      return {
        ...state,
        submittingAnswer: false,
        error: action.error,
      }
    case AIV_SET_ACTIVE_ITEM :
      return {
        ...state,
        activeItem: action.activeItem,
        completed: action.completed,
        selectedAnswer: '', // this might eventually need attention
      }
    case AIV_SET_MOST_RECENT_ACTIVITY :
      let selectedAnswer = ''
      if (action.mostRecentActivity.response) {
        selectedAnswer = action.mostRecentActivity.response
      }
      return {
        ...state,
        completed: true,
        selectedAnswer,
        mostRecentActivity: action.mostRecentActivity,
      }
    case AIV_CLEAR_MOST_RECENT_ACTIVITY : 
      return {
        ...state,
        mostRecentActivity: null,
      }
    default :
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/assignmentsItemView.js